<script>
  import { _ } from "svelte-i18n"
  import { push } from "svelte-spa-router"
  import { declination } from "../../../../helpers"

  import DateComponent from "../../../custom/DateComponent.svelte"

  export let item

  const goToLastPage = (item) => {
    const lastCommentId = item.last_comment.id;

    push(`/topic/${item.id}?cId=${lastCommentId}&chId=0&p=${item.comment_page_count}`);
  }
</script>

<div class="card" on:click={() => push(`/topic/${item.id}`)}>
  <div 
    class="card__image"
    style:background={`url("${item.preview_image}")`}
  />
  <div class="card__body">
    <div class="card__title text-grey text-bold">{item.title}</div>
    <div class="card__description text-grey">{item.preview_text}</div>
  </div>
  <div class="card__comments comments">
    <div>
      <div class="comments__count text-bold">
        <i class="comments__icon icon-comment-circle" />
        <div>
          { declination(item.comments_count, $_('oneMessage'), $_('twoMessage'), $_('fiveMessage')) }
        </div>
      </div>
    
      {#if item.last_comment}
        <div class="comments__user text-grey text-bold">
          {item.last_comment.first_name} {item.last_comment.last_name}
        </div>
        <div class="comments__date">
          <DateComponent createdDate={item.last_comment.created_at} />
        </div>
      {/if}
    </div>

    
      <div class="comments__pagination text-bold">
        {$_('page')} 
        <div class="comments__number">1</div> 

        {#if item.comment_page_count > 1}
          ... 
          <div 
            class="comments__number" 
            on:click|stopPropagation={() => goToLastPage(item)}
          >
            {item.comment_page_count}
          </div>
        {/if}
      </div>
  </div>
</div>

<style lang="scss">
  .card {
    border: 2px solid #F0F0F0;
    padding: 20px;
    margin-bottom: 16px;
    border-radius: 10px;
    min-height: 152px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 148px auto 150px;
    grid-gap: 16px;
    cursor: pointer;
  }

  .card__image {
    height: 112px;
    width: 148px;
    background-size: cover !important;
    background-color: red;
    border-radius: 10px;
    background-position: center !important;
    background-color: antiquewhite !important;
  }

  .card__title {
    font-size: 16px;
    line-height: 23px;
  }

  .card__description {
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
    word-break: break-word;
  }

  .card__comments {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .comments__count {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.04em;
    color: #5A5F6D99;
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }

  .comments__pagination {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.04em;
    color: #5A5F6D99;
    display: flex;
  }

  .comments__number {
    color: #8494F1;
    margin: 0 8px;
  }

  .comments__user {
    font-size: 14px;
    line-height: 18px;
    margin-top: 13px;
  }

  .comments__date {
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: #BDBFC4;
    margin-top: 4px;
  }

  .comments__icon {
    font-size: 14px;
    display: flex;
    align-items: center;
    padding-right: 2px;
  }

  .comments__icon::before {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    color: #BDBFC4;
    margin: 0;
  }

  @media (min-width: 450px ) and (max-width: 576px) {
    .card {
      grid-template-columns: auto 141px;
      grid-gap: 28px;
      min-height: auto;
    }

    .card__image {
      display: none;
    }
  }

  @media (min-width: 320px) and (max-width: 1000px) {
    .card:last-child {
      margin-bottom: 80px;
    }
  }

  @media (max-width: 450px) {
    .card {
      grid-template-columns: auto;
      border: none;
      border-radius: 0;
      margin-bottom: 0;
      position: relative;

      &::after {
        content: "";
        border-bottom: 8px solid rgb(243, 243, 244) !important;
        position: absolute;
        height: 8px;
        bottom: 0;
        left: -18px;
        right: -18px;
      }
    }

    .card:last-child {
      &::after {
        display: none;
      }
    }

    .comments__pagination {
      margin-top: 4px;
    }

    .comments__count {
      margin-bottom: 4px;
    }

    .comments__date,
    .comments__user {
      display: inline;
    }

    .card__image {
      width: 100%;
      height: 200px;
    }

    .comments__icon {
      font-size: 16px;
    }

    .comments__icon::before {
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>